import { useState, useEffect } from 'react';
import { launchdarkly } from './launchdarkly';

// TODO: Refactor. We can use react-query to handle this
export const useRedesignView = () => {
  const [isRedesignEnabled, setRedesignEnabled] = useState(true); // Assume they have access until LD says otherwise.
  const [isLoading, setIsLoading] = useState(true);

  const NEW_ORDER_EXP = 'online-visibility-enable-new-bookings-experience';

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const featureFlags = await launchdarkly();
        setRedesignEnabled(featureFlags[NEW_ORDER_EXP]);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  return { isRedesignEnabled, isLoading };
};
